function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.9605 0.132239C24.7735 -0.385757 26.6631 0.664039 27.1811 2.47702C27.2683 2.78204 27.3125 3.09772 27.3125 3.41494V6.27296H30.7265C32.6121 6.27296 34.1406 7.80149 34.1406 9.68702V30.1714C34.1406 32.0569 32.6121 33.5854 30.7265 33.5854H3.41406C1.52853 33.5854 0 32.0569 0 30.1714H0.0455825C0.0152806 29.9878 0 29.8018 0 29.6154V9.26761C0 7.7433 1.01048 6.40367 2.47615 5.98491L22.9605 0.132239ZM13.8953 30.1714H30.7265V9.68702H27.3125L27.3125 13.1011H30.7265V16.5151H27.3125L27.3125 23.7627C27.3125 25.287 26.302 26.6266 24.8363 27.0454L13.8953 30.1714ZM3.41405 9.26757V29.6153L23.8984 23.7626V3.4149L3.41405 9.26757ZM20.4844 13.1011C20.4844 14.0438 19.7201 14.8081 18.7773 14.8081C17.8346 14.8081 17.0703 14.0438 17.0703 13.1011C17.0703 12.1583 17.8346 11.3941 18.7773 11.3941C19.7201 11.3941 20.4844 12.1583 20.4844 13.1011Z",
  fill: "#02CC9A"
});

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.8163cd8b.svg";
export { ForwardRef as ReactComponent };